/** @format */

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { HmfCheckboxComponent } from '@dsg-tech/homefield-angular';

@Component({
  selector: 'shared-totf-components-compare-checkbox',
  imports: [HmfCheckboxComponent],
  templateUrl: './compare-checkbox.component.html',
  styleUrls: ['./compare-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareCheckboxComponent {
  readonly checked = input(false);
  readonly check = output<boolean>();
  readonly tabPressed = output<void>();

  onCompareChange(event: Event): void {
    event.preventDefault();
    this.check.emit(!this.checked());
  }
}
